import { useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PatientListingPageComponent } from 'src/clinic/views/patientListing/PatientListingPage'
import { GenericHeaderBackButton } from 'src/consumer/components/ActivityPlansPage/MyPlanComponents'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'

export default function PatientListingPageForMentor() {
  const { clinicId } = useParams()
  const { mentorClinicAssociationData } = useContext(MentorProfileContext)

  const thisClinicData = mentorClinicAssociationData?.find((item) => item?.id === clinicId)

  return (
    <>
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <PatientListingPageComponent
        clinicLocationId={clinicId}
        clinicBrandId={thisClinicData?.clinicBrandId}
        clinicLocationName={thisClinicData?.name}
        canEditPatient={true}
      />
    </>
  )
}
